import EventOpsResourcesCore from './EventOpsResourcesCore';
import withEventOpsAutoLoad from './withEventOpsAutoLoad';
import withErrorCatcher from './withErrorCatcher';
import withDates from './withDates';

export default withErrorCatcher(withEventOpsAutoLoad(withDates(EventOpsResourcesCore)));
